import React, { useEffect, useRef, useState } from 'react';
import Form from 'react-bootstrap/Form';
import type { UseFormRegister, RegisterOptions } from 'react-hook-form';
import './textAreaConContador.scss';

type Props = {
  formControlKey?: string;
  id: string;
  register: UseFormRegister<any>;
  required?: boolean;
  maxLength?: number;
  rows?: number;
  placeholder?: string;
  name?: string;
  defaultValue?: string;
  disabled?: boolean;
};

const TextAreaConContador: React.FC<Props> = ({
  formControlKey,
  id,
  register,
  required,
  maxLength = 2000,
  rows = 2,
  placeholder = 'Escriba su respuesta',
  name,
  defaultValue,
  disabled
}) => {
  const inputRef = useRef<HTMLTextAreaElement | null>(null);
  const [len, setLen] = useState<number>(defaultValue?.length ?? 0);

  const rules: RegisterOptions = {
    required: required ? 'Este campo es obligatorio' : false,
    ...(maxLength
      ? { maxLength: { value: maxLength, message: `Máximo ${maxLength} caracteres` } }
      : {}),
  };

  const fieldName = name ?? id;

  const reg = register(fieldName, rules);

  useEffect(() => {
    const v = inputRef.current?.value ?? '';
    setLen(v.length);
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (maxLength && e.target.value.length > maxLength) {
      e.target.value = e.target.value.slice(0, maxLength);
    }
    setLen(e.target.value.length);
    reg.onChange(e);
  };

  const setRefs = (el: HTMLTextAreaElement | null) => {
    inputRef.current = el;
    if (typeof reg.ref === 'function') reg.ref(el);
    else (reg.ref as React.MutableRefObject<HTMLTextAreaElement | null>).current = el;
  };

  return (
    <div className="textarea-wrapper">
      <Form.Control
        key={formControlKey && formControlKey}
        as="textarea"
        id={id}
        name={reg.name}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        ref={setRefs}
        onChange={handleChange}
        onBlur={reg.onBlur}
        defaultValue={defaultValue}
        disabled={disabled}
      />
      {!!maxLength && (
        <span
          className={`char-counter 
            ${disabled
              ? 'disabled'
              : ''
            } 
            ${maxLength - len <= 0
              ? 'limit-reached'
              : maxLength - len <= (maxLength*.05)
              ? 'limit-almost-reached'
              : ''
          }`}
        >
          {len}/{maxLength}
        </span>
      )}
    </div>
  );
};

export default TextAreaConContador;